import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { formConstant } from '../../../../../config';
import { PageParams } from '../../../../core/models/page-params.model';
import { IPaginatorProperties } from '../../../../core/models/paginator.interface';
import { NotificationService } from '../../../../core/services/notification.service';
import { UserService } from '../../../../core/services/user.service';
import { IService } from '../../models/shipment-price.interface';
import { ShipmentPriceService } from '../../services/shipment-price.service';
import { ServiceComponent } from './service/service.component';

@Component({
    selector: 'eci-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnInit {

    public pageParams: PageParams = new PageParams();
    public currentSort: Sort;
    public form: FormGroup;

    public displayedColumns = ['serviceId', 'serviceName'];
    public showLoader: boolean = false;
    public dataSource: MatTableDataSource<IService> = new MatTableDataSource<IService>([]);

    constructor(private userSvc: UserService,
                private dialog: MatDialog,
                private notify: NotificationService,
                private shipmentPriceSvc: ShipmentPriceService,
                private router: Router,
    ) {
    }

    ngOnInit(): void {
        if (this.isAdmin) {
            this.displayedColumns.push(...['createdBy', 'active', 'edit', 'delete']);
        }
        this.form = this.initializeForm();
        this.searchSubscriber();
        this.getService();
    }

    private initializeForm(): FormGroup {
        this.pageParams.pageSize = formConstant.pageSize;
        this.pageParams.pageIndex = 0;
        return new FormGroup({
            search: new FormControl(''),
        });

    }
    private searchSubscriber(): void {
        this.form.get('search').valueChanges.pipe(debounceTime(500))
            .subscribe((value) => {
                this.getService(/*this.pageParams.pageIndex, this.pageParams.pageSize, value,*/);
            });
    }

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    private getService(
        page: number = this.pageParams.pageIndex + 1 || 1,
        limit: number = this.pageParams.pageSize,
        q: string = this.form.get('search')?.value || '',
        orderField: string = this.currentSort?.active || '',
        orderDir: string = this.currentSort?.direction.toUpperCase() || '',
    ): void {
        this.shipmentPriceSvc.get<IPaginatorProperties<IService>>('service', page, limit, q, {}, orderField, orderDir)
            .subscribe((data) => {
                if (!data) {
                    return;
                }
                this.dataSource = new MatTableDataSource<IService>(data.items);
                this.pageParams.pageSize = data.meta.itemsPerPage;
                this.pageParams.pageIndex = data.meta.currentPage - 1;
                this.pageParams.length = data.meta.totalItems;
            });
    }

    public openDialog(serviceDetail?: IService): void {
        const dialogRef = this.dialog.open(ServiceComponent,
            {
                maxHeight: '800px',
                width: '640px',
            },
        );
        dialogRef.componentInstance.createMode = !serviceDetail;
        dialogRef.componentInstance.service = !serviceDetail ? undefined : serviceDetail;
        dialogRef.componentInstance.title = !serviceDetail ? 'Add Service' : 'Edit Service';
        dialogRef.afterClosed()
            .subscribe(() => {
                this.getService();
            });
    }

    public onStatusChange(event: { id: number; status: boolean }): void {
        this.showLoader = true;
        this.shipmentPriceSvc.updateStatus('service', event.id, event.status).subscribe((v) => {
            this.notify.showSuccessMessage(`Update successfully`);
            this.getService();
        }, (err) => {
            this.notify.showError(err.error.message);
            this.showLoader = false;
        });
    }

    public navigateTo(item): void {
        this.router.navigate([`/shipment-price/single-service/${item.id}`]);
    }

    public pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        this.getService();

    }

    public sortData(sort: Sort): void {
        this.currentSort = sort;
        this.getService();
    }

    public onDelete(id: number): void {
        this.showLoader = true;
        this.shipmentPriceSvc.delete('service', id).subscribe((v) => {
            this.notify.showSuccessMessage(`Delete successfully`);
            this.getService();
        }, (err) => {
            this.notify.showError(err.error.message);
            this.showLoader = false;
        });
    }
}
